module.exports = __webpack_public_path__ + "img/ja_JP.db66c1f.jpg";